import React from 'react';
import { LogoProps } from './types';

export function Comments({ width, height, color }: LogoProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 23 23" fill="none">
      <path
        d="M14.7503 2.83366V10.417H4.10116L2.83366 11.6845V2.83366H14.7503ZM15.8337 0.666992H1.75033C1.15449 0.666992 0.666992 1.15449 0.666992 1.75033V16.917L5.00033 12.5837H15.8337C16.4295 12.5837 16.917 12.0962 16.917 11.5003V1.75033C16.917 1.15449 16.4295 0.666992 15.8337 0.666992ZM21.2503 5.00033H19.0837V14.7503H5.00033V16.917C5.00033 17.5128 5.48783 18.0003 6.08366 18.0003H18.0003L22.3337 22.3337V6.08366C22.3337 5.48783 21.8462 5.00033 21.2503 5.00033Z"
        fill={color}
      />
    </svg>
  );
}

export default Comments;
